export const adminAffiliatesApi = {

    getAll () {
        return axios.get(`/api/admin/affiliate`)
    },

}
